import { render, staticRenderFns } from "./shopStorageLocker.vue?vue&type=template&id=52a094b0&scoped=true"
import script from "./shopStorageLocker.vue?vue&type=script&lang=ts"
export * from "./shopStorageLocker.vue?vue&type=script&lang=ts"
import style0 from "./shopStorageLocker.vue?vue&type=style&index=0&id=52a094b0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a094b0",
  null
  
)

export default component.exports